import { render, staticRenderFns } from "./BasicModalLayout.vue?vue&type=template&id=7f9a1196&"
import script from "./BasicModalLayout.vue?vue&type=script&lang=js&"
export * from "./BasicModalLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports